import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, TableCell } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
  labelSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}

export default function SortTableCell({ children, labelSx, sx }: Props) {
  return (
    <TableCell sx={sx}>
      <Box
        component="span"
        sx={[
          { display: 'inline-flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' },
          ...(Array.isArray(labelSx) ? labelSx : [labelSx]),
        ]}
      >
        {children}
        <KeyboardArrowDownIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
      </Box>
    </TableCell>
  );
}
